export const inlineStyleOverrides = {
  control: {
    'min-height': 37,
    'border-radius': 0,
    'border-right': 0,
    'border-color': '#e4e4e4',
    'background-color': 'white',
    'width': '200px'
  }
};
